export default __webpack_public_path__ + "static/media/empty.828962f3.svg";